import { FileUploadContent, FileUploadIcons } from '@traceair/tds/dist/file_upload/components';
import { classes, stylesheet } from 'typestyle';
import { Blue0, Blue80, Gray10, Gray50 } from '@traceair/tds';
import { Accept, FileWithPath, useDropzone } from 'react-dropzone';

const css = stylesheet({
  container: {
    position: 'relative',
    padding: '30px 21px',
    textAlign: 'center',
    cursor: 'pointer',
    border: `1px dashed ${Gray50}`,
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 8,
    $nest: {
      '&:hover': {
        borderColor: Blue80,
        backgroundColor: Blue0,
      },
    },
  },
  containerDisabled: {
    border: `1px dashed ${Gray50} !important`,
    backgroundColor: `${Gray10} !important`,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
  containerDraggingOver: {
    borderColor: `${Blue0} !important`,
  },
  containerReducedHeight: {
    $nest: {
      '&&': {
        padding: '20px 21px',
      },
    },
  },
  dragCover: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    background: Blue0,
    border: `4px dashed ${Blue80}`,
  },
});

interface Props {
  accept: Accept;
  description: string;
  disabled?: boolean;
  dragOverText: string;
  fileFormatIcons: string[];
  hideIcons?: boolean;
  multiple?: boolean;
  onChange: (files: FileWithPath[]) => void;
  reduceHeight?: boolean;
  title: string;
}

export const FileUpload = ({
  accept,
  description,
  disabled,
  dragOverText,
  fileFormatIcons,
  hideIcons,
  multiple,
  onChange,
  reduceHeight,
  title,
}: Props) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    disabled,
    multiple,
    onDrop: onChange,
  });

  return (
    <div
      {...getRootProps()}
      className={classes(
        css.container,
        disabled && css.containerDisabled,
        isDragActive && css.containerDraggingOver,
        reduceHeight && !hideIcons && css.containerReducedHeight,
      )}
    >
      {isDragActive && <div className={css.dragCover}>{dragOverText}</div>}

      <input {...getInputProps()} />
      {!hideIcons && <FileUploadIcons disabled={disabled} formats={fileFormatIcons} forceShowStroke={true} />}

      <FileUploadContent disabled={disabled} title={title} description={description} linkText={' click to browse'} />
    </div>
  );
};
